import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class ApiBaseUrlInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // assets => don't touch
    if (req.url.startsWith('/assets/')) {
      return next.handle(req);
    }

    if (req.url.startsWith('http')) {
      return next.handle(req); // already absolute
    }
    
    const apiReq = req.clone({ url: `${environment.apiBaseUrl}${req.url}` });
    return next.handle(apiReq);
  }
}
